"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferClient = void 0;
const common_sdk_1 = require("@orca-so/common-sdk");
const __1 = require("../");
const types_1 = require("../types");
const lodash_1 = require("lodash");
class OfferClient {
    constructor(ctx, publicKey, data, configData, pda, marketId, configId) {
        this.ctx = ctx;
        this.data = data;
        this.configData = configData;
        this.publicKey = publicKey;
        this.pda = pda;
        this.marketId = marketId;
        this.configId = configId;
    }
    static getOffer(ctx, configId, marketId, offerId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId, marketId);
            const offerPubkey = pda.getOfferPDA(offerId).key;
            const configAccount = pda.getConfigPDA().key;
            const offerData = (yield ctx.program.account.offer.fetch(offerPubkey));
            if (!offerData) {
                throw new Error(`Offer ${offerId} not found`);
            }
            const configData = (yield ctx.program.account.escrowConfig.fetch(configAccount));
            if (!configData) {
                throw new Error(`Config Account ${configAccount} not found`);
            }
            return new OfferClient(ctx, offerPubkey, Object.assign(Object.assign({}, offerData), { pubkey: offerPubkey }), Object.assign(Object.assign({}, configData), { pubkey: configAccount }), pda, marketId, configId);
        });
    }
    static makeOffer(ctx, marketId, configId, side, maker, tokenMint, bondType, minTradeSize, tokenAmount, fiatAmount, encryptedBankName, encryptedAccountNumber, encryptedAccountName, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId, marketId);
            const configAccount = pda.getConfigPDA().key;
            const marketAccount = pda.getMarketPDA(tokenMint).key;
            const marketTokenAccount = pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = pda.getMarketNativeVaultPDA(tokenMint).key;
            let configAccountData = (yield ctx.program.account.escrowConfig.fetch(configAccount));
            if (!configAccountData) {
                throw new Error(`config account:  ${configAccount} not found`);
            }
            const offerPDA = pda.getOfferPDA(configAccountData.currentOfferId);
            const makerTokenAccount = yield (0, common_sdk_1.deriveATA)(maker, tokenMint);
            const isEncryptData = encryptedBankName != null &&
                encryptedAccountNumber != null &&
                encryptedAccountName != null &&
                nonce != null;
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Sell) && !isEncryptData) {
                throw new Error(`Seller must be encrypt payment info`);
            }
            // add kyc cert if is buy offer
            let prependIxs = [];
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                // Get or create default joinner kyc cert
                const userKycCertPda = pda.getKycCertPDA(maker, tokenMint);
                const accountInfo = yield ctx.connection.getAccountInfo(userKycCertPda.key);
                if (accountInfo == null) {
                    const initKycCertIx = (yield ctx.ixs.initKycCertIx({
                        marketAccount: marketAccount,
                        caller: maker,
                        user: maker,
                        tokenMint,
                        kycCertPubkey: userKycCertPda.key,
                        kycCertBump: userKycCertPda.bump,
                    })).ix;
                    if (!initKycCertIx) {
                        throw new Error("Fail to get the initialize kyc cert instruction");
                    }
                    prependIxs.push(initKycCertIx);
                }
                remainingAccounts = (0, __1.getRemaningAccounts)([userKycCertPda.key]);
            }
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                let buyerKycCert = pda.getKycCertPDA(maker, tokenMint);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            const tx = (yield ctx.ixs.makeOfferIx({
                configAccount: configAccount,
                marketAccount: marketAccount,
                marketTokenVault: marketTokenAccount,
                marketNativeVault: marketNativeAccount,
                side: side,
                bondType: bondType,
                offerPDA,
                tokenMint,
                userTokenAccount: makerTokenAccount,
                user: maker,
                minTradeSize,
                tokenAmount: tokenAmount,
                fiatAmount: fiatAmount,
                remainingAccounts,
                encryptedBankName,
                encryptedAccountNumber,
                encryptedAccountName,
                nonce,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx, id: configAccountData.currentOfferId };
        });
    }
    static makeOfferOracle(ctx, marketId, configId, side, maker, tokenMint, bondType, minTradeSize, tokenAmount, fiatAmount, oracleProduct, oraclePrice, encryptedBankName, encryptedAccountNumber, encryptedAccountName, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const pda = new __1.PDA(ctx.program.programId, configId, marketId);
            const configAccount = pda.getConfigPDA().key;
            const marketAccount = pda.getMarketPDA(tokenMint).key;
            const marketTokenAccount = pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = pda.getMarketNativeVaultPDA(tokenMint).key;
            let configAccountData = (yield ctx.program.account.escrowConfig.fetch(configAccount));
            if (!configAccountData) {
                throw new Error(`market account:  ${configAccount} not found`);
            }
            const offerPDA = pda.getOfferPDA(configAccountData.currentOfferId);
            const makerTokenAccount = yield (0, common_sdk_1.deriveATA)(maker, tokenMint);
            const isExistEncryptData = encryptedBankName == null
                ? false
                : encryptedAccountNumber == null
                    ? false
                    : encryptedAccountName == null
                        ? false
                        : nonce == null
                            ? false
                            : true;
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Sell) && !isExistEncryptData) {
                throw new Error(`Seller must be encrypt payment info`);
            }
            // add kyc cert if is buy offer
            let prependIxs = [];
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                // Get or create default joinner kyc cert
                const userKycCertPda = pda.getKycCertPDA(maker, tokenMint);
                const accountInfo = yield ctx.connection.getAccountInfo(userKycCertPda.key);
                if (accountInfo == null) {
                    const initKycCertIx = (yield ctx.ixs.initKycCertIx({
                        marketAccount: marketAccount,
                        caller: maker,
                        user: maker,
                        tokenMint,
                        kycCertPubkey: userKycCertPda.key,
                        kycCertBump: userKycCertPda.bump,
                    })).ix;
                    if (!initKycCertIx) {
                        throw new Error("Fail to get the initialize kyc cert instruction");
                    }
                    prependIxs.push(initKycCertIx);
                }
                remainingAccounts = (0, __1.getRemaningAccounts)([userKycCertPda.key]);
            }
            if ((0, lodash_1.isEqual)(side, types_1.TradeSide.Buy)) {
                let buyerKycCert = pda.getKycCertPDA(maker, tokenMint);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            const tx = (yield ctx.ixs.makeOfferOracleIx({
                configAccount: configAccount,
                marketAccount: marketAccount,
                marketTokenVault: marketTokenAccount,
                marketNativeVault: marketNativeAccount,
                side: side,
                bondType: bondType,
                offerPDA,
                tokenMint,
                userTokenAccount: makerTokenAccount,
                user: maker,
                minTradeSize,
                tokenAmount: tokenAmount,
                fiatAmount: fiatAmount,
                remainingAccounts,
                oracleProduct,
                oraclePrice,
                encryptedBankName,
                encryptedAccountNumber,
                encryptedAccountName,
                nonce,
            }))
                .toTx()
                .prependInstructions(prependIxs);
            return { tx, id: configAccountData.currentOfferId };
        });
    }
    cancelOffer() {
        return __awaiter(this, void 0, void 0, function* () {
            const maker = this.data.makerAuthority;
            const tokenMint = this.data.tokenMint;
            const marketAccount = this.pda.getMarketPDA(tokenMint).key;
            const marketTokenAccount = this.pda.getMarketTokenVaultPDA(tokenMint).key;
            const marketNativeAccount = this.pda.getMarketNativeVaultPDA(tokenMint).key;
            const makerTokenAccount = yield (0, common_sdk_1.deriveATA)(maker, tokenMint);
            let remainingAccounts = (0, __1.getRemaningAccounts)([]);
            if ((0, lodash_1.isEqual)(this.data.side, types_1.TradeSide.Buy)) {
                let buyerKycCert = this.pda.getKycCertPDA(maker, tokenMint);
                remainingAccounts = (0, __1.getRemaningAccounts)([buyerKycCert.key]);
            }
            const tx = (yield this.ctx.ixs.cancelOfferIx({
                marketAccount: marketAccount,
                marketTokenVault: marketTokenAccount,
                marketNativeVault: marketNativeAccount,
                offerAccount: this.publicKey,
                tokenMint,
                userTokenAccount: makerTokenAccount,
                user: maker,
                remainingAccounts,
            })).toTx();
            return { tx };
        });
    }
}
exports.OfferClient = OfferClient;
